export default "__VITE_ASSET__BZVmcO$n__"